import { createFileRoute } from '@tanstack/react-router';

import { CategoryFormScreen } from '@/features/catalog/CategoryForm';

/** Правка категории. */
export const Route = createFileRoute('/_app/catalog_/categories_/$categoryId')({
  component: EditCategoryRoute,
});

function EditCategoryRoute() {
  const { categoryId } = Route.useParams();
  // Ключ по идентификатору: форма берёт начальные значения при монтировании.
  return <CategoryFormScreen key={categoryId} categoryId={categoryId} />;
}
